import { Component, Fragment } from 'react'
import Slider from 'react-slick'
import API from '../../api'

function CustomArrows(props) {
  const { type, onClick } = props

  return (<div className={`custom-slick-button ${type === 'next' ? 'next' : 'prev'}`} onClick={onClick}>
    <i className={`font-icons ${type === 'next' ? 'right-arrow-icon' : 'left-arrow-icon'}`} />
  </div>)
}

export default class ShopSlider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      photos: props.background ? [{
        url: props.background,
      }] : [],
    }
  }

  componentDidMount() {
    this.getPhotos()
  }

  componentDidUpdate(prevProps) {
    if(JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
      this.getPhotos()
    }
  }

  getPhotos() {
    if(this.props.photos) {
      this.setState({
        photos: this.props.photos,
      })
    } else {
      API(this.props.apiUrl || `shop/${this.props.slug}/images/`, false, false, !!this.props.apiUrl).get().then((photos) => {
        const results = photos.results || photos
        this.setState({
          photos: [...this.state.photos, ...results],
        })
      })
    }
  }

  handleClick = function(event) {
    event.stopPropagation()
    this.props.shopUrl && window.open(this.props.shopUrl, '_blank')
  }

  render() {
    const settings = {
      dots: true,
      dotsClass: 'custom-paging',
      customPaging: (index) => {
        return <Fragment>{ index + 1 }/{this.state.photos.length}</Fragment>
      },
      arrows: true,
      nextArrow: <CustomArrows type='next' />,
      prevArrow: <CustomArrows type='prev' />,
      slidesToShow: 1,
      lazyLoad: 'ondemand',
      fade: true,
      responsive: [{ breakpoint: 1025, settings: { arrows: true, slidesToShow: 1, slidesToScroll: 1 } }],
    }

    return (
      <Slider className='slick-slider' {...settings}>
        {
          this.state.photos.map((photo) => {
            return (
              <div
                className='relative'
                key={photo.url}
                onClick={(e) => {
                  this.handleClick(e)
                }}
              >
                <img className='img fade-onload' src={photo.url} />
              </div>
            )
          })
        }
      </Slider>
    )
  }
}
